import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class ShoppingCartApi {

    static getList() {
        return HTTP.get(config.shoppingCartApi.shoppingCart)
            .then(response => response.data)
    }

    static add(shoppingCartItem) {
        return HTTP.post(config.shoppingCartApi.shoppingCart, shoppingCartItem)
            .then(response => response.data)
    }

    static remove(shoppingCartItemId) {
        return HTTP.delete(`${config.shoppingCartApi.shoppingCart}/item/${shoppingCartItemId}`)
            .then(response => response.data)
    }

    static update(shoppingCartItem) {
        return HTTP.put(config.shoppingCartApi.shoppingCart, shoppingCartItem)
            .then(response => response.data)
    }

    static getSeasonlist() {
        return HTTP.get(config.shoppingCartApi.season)
            .then(response => response.data)
    }

    static getCountryList() {
        return HTTP.get(config.shoppingCartApi.country)
            .then(response => response.data)
    }

    static checkout(cartId, order) {
        return HTTP.post(`${config.shoppingCartApi.checkout}/${cartId}`, order)
            .then(response => response.data)

    }
}